import { render, staticRenderFns } from "./report-order-columns.vue?vue&type=template&id=d3ae8e3c&"
import script from "./report-order-columns.vue?vue&type=script&lang=ts&"
export * from "./report-order-columns.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports